import { getError } from './helpers';

export default class EventDataDAO {
  constructor(urls) {
    this.EVENT_DATA_UPDATE_URL = urls.EVENT_DATA_UPDATE_URL;
  }

  /**
   * Update user event data
   * @param accountId (Number)
   * @param updates (Array):
   * @returns {Promise}
   */
  update({ accountId, updates }) {
    const accountUpdateQueryParams = [ 'location', 'locationName', 'scheduled', 'durationMinutes', 'note' ];
    const accountUserEventDataQueryParams = [ 'flagged', 'attended', 'color' ];
    return new Promise((resolve, reject) => {
      const fixedUpdates = _.map(updates, ({ eventId, accountUpdates, users }) => {
        return {
          eventId,
          accountUpdates: _.pick(accountUpdates, accountUpdateQueryParams),
          users: _.mapObject(users, fields => _.pick(fields, accountUserEventDataQueryParams))
        };
      });

      $.ajax({
        method: 'POST',
        contentType: 'application/json',
        url: this.EVENT_DATA_UPDATE_URL,
        data: JSON.stringify({ accountId, updates: fixedUpdates })
      }).then((resp) => {
        resolve(resp);
      }, (jqXhr) => {
        reject(getError(jqXhr, 'Failed to update Event Data.'));
      });
    });
  }
}


// WEBPACK FOOTER //
// ./src/js/util/dao/EventDataDAO.js